<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
    <circle cx="30" cy="30.3521" r="30" fill="#A6192E" />
    <path
      d="M40.7042 29.2285C41.5337 29.7469 41.5337 30.9548 40.7042 31.4732L24.525 41.5852C23.6435 42.1362 22.5 41.5024 22.5 40.4629V20.2388C22.5 19.1993 23.6435 18.5655 24.525 19.1165L40.7042 29.2285Z"
      fill="white"
    />
    <path
      d="M40.7042 29.2285C41.5337 29.7469 41.5337 30.9548 40.7042 31.4732L24.525 41.5852C23.6435 42.1362 22.5 41.5024 22.5 40.4629V20.2388C22.5 19.1993 23.6435 18.5655 24.525 19.1165L40.7042 29.2285Z"
      fill="white"
    />
  </svg>
</template>
